import React, { Component } from 'react';
import './App.css';

import Header from './components/Header';
import Slider from './components/Slider';
import Footer from './components/Footer';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <Slider />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js